<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.profile')"
    :onFetchData="onFetchData"
    :onFormSubmit="onFormSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Profile extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'email',
        label: this.$t('adminUser.email'),
        minWidth: 140
      },
      {
        prop: 'name',
        label: this.$t('adminUser.name'),
        minWidth: 120,
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'email',
        label: this.$t('adminUser.email'),
        renderCell: {
          component: 'input',
          props: {
            disabled: true,
          }
        }
      },
      {
        prop: 'name',
        label: this.$t('adminUser.name'),
        renderCell: {
          component: 'input',
        }
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   */
  actions() {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'profile.edit' },
          can: []
        }
      },
      {
        component: 'routeButton',
        props: {
          label: this.$t('changePassword'),
          to: { name: 'profile.change_password' },
          can: []
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get('/mine');
      return { data };
    }
  }

  async onFormSubmit({ data }) {
    const body = data;

    await this.$request.put('mine', body);
    this.$message.success('更新成功');
    this.$router.push({ name: 'profile.show' });
  }
}

export const route = [
  {
    path: '/profile',
    name: 'profile.show',
    component: Profile,
    props: {
      type: 'show',
    },
  },
  {
    path: '/profile/edit',
    name: 'profile.edit',
    component: Profile,
    props: {
      type: 'edit'
    }
  }
]
</script>
